import { Observable } from "rxjs";
import { type AnyElement } from "@zyzgroup/core-common";

// 监控 DOM 改变
export function mutation$(
  el: AnyElement | Document,
  options: MutationObserverInit = {
    attributes: true,
    childList: true,
    subtree: true
  }
): Observable<MutationRecord[]> {
  return new Observable((observer) => {
    const mo = new MutationObserver(
      (records: MutationRecord[], _: MutationObserver) => {
        // for (const mutation of records) {
        //   if (mutation.type === "childList") {
        //     mutation.addedNodes.forEach((node) => {
        //       if (node.id === "targetElement") {
        //         // 目标元素已经插入到 DOM 中
        //         o.disconnect(); // 停止监听
        //       }
        //     });
        //   }
        // }
        observer.next(records);
      }
    );
    mo.observe(el, options);
    return () => {
      mo.disconnect(); // 停止监听
    };
  });
}

// 目标元素是否已经插入到 DOM
export function waitElementAddedInDOM(
  parent: AnyElement | Document,
  child: AnyElement
): Promise<boolean> {
  return new Promise((resolve) => {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach((node) => {
            if (node.isEqualNode(child)) {
              observer.disconnect();
              resolve(true);
            }
          });
        }
      }
    });
    observer.observe(parent, { childList: true });
  });
}
